export { default as TalleresListar } from './Listar'
export { default as TallerDetalle } from './Detalle'